import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const VehiclesAndTheirCurrentStatus = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [totalHours, setTotalHours] = useState("");
  const [statesList, setStatesList] = useState([]);
  const [selState, setSelState] = useState("");

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !selState) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE",
        "DRIVERNAME",
        "MAKE",
        "CURRENTSTATE",
        "HOURSINSTATE",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const stateFilter = !selState || item?.CURRENTSTATE === selState;

    return textMatch && stateFilter;
  });


    useEffect(() => {
    let total = 0;
    filteredData?.forEach((item) => {
      total += parseFloat(item?.HOURSINSTATE || 0);
    });
    setTotalHours(total);
  }, [filteredData]);


  useEffect(() => {
    initialData();
  }, []);

  console.log(statesList);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1322`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = [...(response.data || [])].sort(
          (a, b) => Number(b.HOURSINSTATE) - Number(a.HOURSINSTATE),
        );

        const setData = new Set(
          response?.data?.map((item) => item?.CURRENTSTATE).filter(Boolean),
        );
        setStatesList([...setData]);

        setVehiclesList(sortedData);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details 1322:", error);
      });
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
       <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Vehicles And Their Current Status
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <div>
          <p>State :</p>
        </div>
        <div>
          <Select
            className="lg:w-64 w-64 lg:ml-2"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={
              selState
                ? { value: selState, label: selState }
                : { value: "", label: "Select State" }
            }
            onChange={(e) => {
              setSelState(e.value);
            }}
            options={[
              { value: "", label: "Select State" },
              ...statesList?.map((item) => ({
                value: item,
                label: item,
              })),
            ]}
          ></Select>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                CURRENT STATE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                HOURS IN STATE
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                // onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.VEHICLE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.DRIVERNAME || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.CURRENTSTATE || "N/A"}
                </td>
                <td className="py-2 px-4 text-right border border-gray-300">
                  {value.HOURSINSTATE
                    ? value.HOURSINSTATE.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end gap-2">
        <p>Total Hours :</p>
        <input
          type="text"
          className="w-32 h-8 border text-right border-black rounded-md"
          value={
            totalHours
              ? totalHours?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : 0
          }
          readOnly
        ></input>
      </div>
    </div>
  );
};

export default VehiclesAndTheirCurrentStatus;
